<template>
  <div>
    <c-table
      ref="table"
      title="배출량조사표"
      tableId="table"
      :merge="grid.merge"
      :columns="grid.columns"
      :data="grid.data"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'emissions',
  components: {
  },
  props: {
    searchParam: {
      type: Object,
      default: function() {
        return {
          plantCd: null,
          year: '',
        };
      },
    },
    height: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'gubun' },
          { index: 1, colName: 'mdmChemId' },
          { index: 2, colName: 'mdmChemId' },
          { index: 3, colName: 'mdmChemId' },
          { index: 4, colName: 'mdmChemId' },
          { index: 5, colName: 'mdmChemId' },
          { index: 6, colName: 'mdmChemId' },
        ],
        columns: [
          {
            name: 'gubun',
            field: 'gubun',
            description: 'description',
            label: '구분',
            align: 'center',
            style: 'width:75px',
            sortable: false,
          },
          {
            name: 'chemNmEn',
            field: 'chemNmEn',
            label: '화학물질',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'casNo',
            field: 'casNo',
            label: 'CAS No.',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'throughput',
            field: 'throughput',
            label: '취급량',
            align: 'center',
            child: [
              {
                name: 'chemOutAmount0',
                field: 'chemOutAmount0',
                label: '생산량(kg/년)',
                align: 'right',
                style: 'width:50px',
                sortable: false,
                type: 'cost',
              },
              {
                name: 'chemOutAmount',
                field: 'chemOutAmount',
                label: '사용량(kg/년)',
                align: 'right',
                style: 'width:50px',
                sortable: false,
                type: 'cost',
              },
            ]
          },
          {
            name: 'limitRepval',
            field: 'limitRepval',
            label: '함유량',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'appliStand',
            field: 'appliStand',
            label: '조사대상범위[무게항유율(%)]',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'chemprod',
            field: 'chemprod',
            label: '사용제품',
            align: 'center',
            child: [
              {
                name: 'materialCd',
                field: 'materialCd',
                label: '자재코드',
                align: 'center',
                style: 'width:100px',
                sortable: false,
              },
              {
                name: 'materialName',
                field: 'materialName',
                label: '화학자재',
                align: 'left',
                style: 'width:200px',
                sortable: false,
              },
              {
                name: 'vendorName',
                field: 'vendorName',
                label: '공급업체',
                align: 'center',
                style: 'width:100px',
                sortable: false,
              },
              {
                name: 'outAmount',
                field: 'outAmount',
                label: '사용량(kg/년)',
                align: 'right',
                style: 'width:80px',
                sortable: false,
                type: 'cost',
              },
            ]
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.chm.inout.emissions.url;
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
  }
};
</script>